/** 
 * Animate time ray on "company" page
 */
(function () {
  if (document.querySelector("html.company")) {

    /**
     * Set the highligted length of the ray
     * 
     * @param {number} length - length to highlight
     */
    const setRayHighlightLength = (length) => {
      document.querySelector("section:nth-child(2) ul li:last-child").style.
        setProperty('background-image', 
          'linear-gradient(#ffc81f 0, #ffc81f ' + length + 'px, #f2f3f3 ' + length + 'px)');
    }

    // set "time ray" length
    const setRayLength = (length) => {
      if (window.innerWidth <= 1024) {
        const topUl = document.querySelector('article#history section:nth-child(2) ul').
          getBoundingClientRect().top;
        const topEl = document.querySelector('article#history section:nth-child(2) ul li:nth-child(12)').
          getBoundingClientRect().top;
        document.querySelector('article#history section:nth-child(2) ul li:last-child').style.
          setProperty('height', topEl - topUl - 20 + 'px');
      } else {
        document.querySelector('article#history section:nth-child(2) ul li:last-child').style.
          setProperty('height', '2280px');
      }
    }

    let timeRayAnimated = false
    let topPos

    // animate time ray on scroll event
    window.addEventListener("scroll", () => {
      topPos = document.querySelector('section:nth-child(2) ul').getBoundingClientRect().top
      if ( window.innerHeight/2 - topPos + 10 > 50) {
        timeRayAnimated = true
        setRayHighlightLength(Math.floor(window.innerHeight/2 - topPos + 10))
        Array.from(document.querySelectorAll('section:nth-child(2) li')).
          map((el) => {
            if (el.getBoundingClientRect().top + 20 < window.innerHeight/2) {
              el.classList.add('highlighted')
            } else {
              el.classList.remove('highlighted')
            }
          });
      } else if (timeRayAnimated) {
        timeRayAnimated = false
        setRayHighlightLength(50)
      }
    })

    window.addEventListener("resize", setRayLength)

    setRayLength()
  }
})()